import React from 'react';
import clsx from 'clsx';
import styles from './index.module.scss';

export interface VideoStreamTargetProps {
  isCapturing?: boolean;
  className?: string;
}

function VideoStreamTarget(props: VideoStreamTargetProps) {
  return (
    <>
      <div
        className={clsx(styles.square, styles.leftSquare, {
          [styles.isCapturing]: props.isCapturing,
        })}
      >
        <div className={clsx(styles.videoTarget, styles.topLeft)} />
        <div className={clsx(styles.videoTarget, styles.bottomLeft)} />
      </div>
      <div
        className={clsx(styles.square, styles.rightSquare, {
          [styles.isCapturing]: props.isCapturing,
        })}
      >
        <div className={clsx(styles.videoTarget, styles.topRight)} />
        <div className={clsx(styles.videoTarget, styles.bottomRight)} />
      </div>
    </>
  );
}

export default VideoStreamTarget;
